import type { Coordinate, Sort } from '.';
import type { UUID } from './identifier';

type GeofenceColor = 'RED' | 'GREEN' | 'BLUE' | 'YELLOW' | 'PURPLE' | 'TOMATO' | 'LIME' | 'SKY' | 'GOLD' | 'PINK' | 'INDIGO' | 'BROWN' | 'TEAL' | 'ORANGE' | 'DEFAULT';

enum GeofenceType {
  BASE = 'BASE',
  CLIENT = 'CLIENT',
  OTHER = 'OTHER',
  HEADQUARTER = 'HEADQUARTER',
  SUPPLY = 'SUPPLY',
  MAINTENANCE = 'MAINTENANCE',
  STATE = 'STATE',
  CITY = 'CITY',
}

enum GeofenceFormat {
  CIRCLE = 'CIRCLE',
  RECTANGLE = 'RECTANGLE',
  DRAWING = 'DRAWING',
}

enum PointOnMapType {
  DESTINATION = 'DESTINATION',
  GEOFENCE = 'GEOFENCE',
  SEARCH = 'SEARCH',
}

interface GeofenceFeatureCollection {
  type: 'FeatureCollection';
  features: [
    {
      type: 'Feature';
      geometry: GeofenceMultiPolygon | GeofenceGeometryPolygon;
      properties: GeofenceProperties;
    },
  ];
}

interface GeofenceMultiPolygon {
  type: 'MultiPolygon';
  coordinates: [number[][][]];
}

interface GeofenceGeometryPolygon {
  type: 'Polygon';
  coordinates: [number[][]];
}

interface GeofenceGeometryPoint {
  type: 'Point';
  coordinates: [number, number];
}

interface GeofenceProperties {
  id: UUID;
  type: GeofenceType;
}

interface GeofenceFilter {
  page?: number;
  search?: string;
  size?: number;
  sort?: Sort[];
}

interface GeofenceMapPoint {
  type: 'Feature';
  geometry: GeofenceGeometryPoint;
  properties: GeofenceProperties;
}

interface GeofenceResume {
  id: UUID;
  lat: number;
  lng: number;
  type: GeofenceType;
  color?: GeofenceColor;
}

interface PlainGeofence {
  id: UUID;
  name: string;
  type: GeofenceType;
  format?: GeofenceFormat;
  radius?: number;
  address: string;
  geometryPoint: GeofenceGeometryPoint;
  geometryPolygon: GeofenceGeometryPolygon;
  area: number;
  color?: GeofenceColor;
  forceVisibility?: boolean;
  idIbgeEstado?: number;
  idIbgeMunicipio?: number;
}

interface PointOnMap {
  address?: string;
  center?: Coordinate;
  type?: PointOnMapType;
  geometryPolygon?: GeofenceGeometryPolygon;
}

interface Geofence extends PlainGeofence {
  geometry: GeofenceGeometryPolygon;
  properties: GeofenceProperties;
}

interface GeofenceValidationQuery {
  name: string;
  address: string;
}

export { GeofenceType, GeofenceFormat, PointOnMapType };

export type {
  GeofenceColor,
  Geofence,
  GeofenceFilter,
  GeofenceGeometryPoint,
  GeofenceGeometryPolygon,
  GeofenceMultiPolygon,
  GeofenceFeatureCollection,
  GeofenceMapPoint,
  GeofenceResume,
  GeofenceProperties,
  GeofenceValidationQuery,
  PlainGeofence,
  PointOnMap,
};
